module.exports = __webpack_public_path__ + "img/biaoqian_canyin.8346278b.png";